import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"
import { cn } from "~/utils/helpers"

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "bg-border-base shrink-0",
        orientation === "horizontal" ? "min-h-[1px] w-full" : "h-full min-w-[1px]",
        className,
      )}
      {...props}
    />
  )
}

export { Separator }
